import React from 'react';
import SectionHeader from './SectionHeader';
import SurfaceCard from './SurfaceCard';
import {Box, BoxProps} from 'components/ui/chakra';

interface FormPanelProps extends BoxProps {
	children: React.ReactNode;
	description?: React.ReactNode;
	eyebrow?: React.ReactNode;
	heading?: React.ReactNode;
}

const FormPanel = ({children, description, eyebrow, heading, ...rest}: FormPanelProps) => (
	<SurfaceCard p={{base: 5, md: 6}} {...rest}>
		{heading && (
			<SectionHeader eyebrow={eyebrow} heading={heading} description={description} mb={5} />
		)}
		<Box>{children}</Box>
	</SurfaceCard>
);

export default FormPanel;
